module.exports = __webpack_public_path__ + "img/Amphibia.c6dcefdb.gif";